import { CheckCircle2 } from "lucide-react";

export default function VerifiedBadge({ size = 14, className = "", show = false }) {
  if (!show) return null;
  return (
    <span
      title="Verified Practitioner"
      data-testid="verified-badge"
      className={`inline-flex items-center justify-center text-secondary ${className}`}
    >
      <CheckCircle2
        size={size}
        strokeWidth={1.5}
        className="fill-secondary text-background"
      />
    </span>
  );
}
